import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  showIcon = true,
  href,
  ...props
}: CTAButtonProps) {
  const sharedClassName = `relative overflow-hidden group bg-gradient-to-r from-gold-dark via-gold-light to-gold-dark bg-[length:200%_auto] text-dark font-bold py-4 px-8 rounded-sm shadow-[0_0_15px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] transition-all duration-300 ${className}`;
  const content = <>
      <span className="relative z-10 flex items-center justify-center gap-3 text-lg uppercase tracking-widest" data-id="element-1">
        {children}
        {showIcon && <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-2" />}
      </span>
      {/* Shimmer effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-shimmer z-0" data-id="element-3" />
    </>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={`inline-block no-underline ${sharedClassName}`} data-id="element-4">
        {content}
      </a>;
  }
  return <button className={sharedClassName} {...props} data-id="element-5">
      {content}
    </button>;
}